/**
 * RTB House (Creative CDN) 이벤트 — `runMode === 'production'` 에서만 전송
 */
export const getRtbMemberId = (): string => {
  if (typeof window === 'undefined') {
    return 'unknown';
  }
  return window.ya__?.hashedMemberNo || 'unknown';
};

export const pushRtbEvents = (...entries: Record<string, unknown>[]): void => {
  if (typeof window === 'undefined' || window.ya__?.runMode !== 'production') {
    return;
  }
  (window.rtbhEvents = window.rtbhEvents || []).push(...entries);
};
